const bookingArrangementItems = document.querySelectorAll('.booking-item-arrangement');
const bookingFoodItems = document.querySelectorAll('.booking-item-food');

export default function initBookingForm() {
    if (bookingArrangementItems) {
        bookingArrangementItems.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.stopPropagation();

                const dataId = e.currentTarget.getAttribute('data-id');
                const arrangementIdInput = document.getElementById('input-arrangement-id');
                arrangementIdInput.value = dataId;

                bookingArrangementItems.forEach((bookingElement) => {
                    bookingElement.classList.remove('booking-item-checked');
                });
                e.currentTarget.classList.add('booking-item-checked');
            });
        });
    }

    if (bookingFoodItems) {
        bookingFoodItems.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.stopPropagation();

                const dataId = e.currentTarget.getAttribute('data-id');
                const foodIdInput = document.getElementById('input-food-id');
                foodIdInput.value = dataId;

                bookingFoodItems.forEach((bookingElement) => {
                    bookingElement.classList.remove('booking-item-checked');
                });
                e.currentTarget.classList.add('booking-item-checked');
            });
        });
    }
}
